module.exports = __webpack_public_path__ + "img/sck_alexflycreat.57878ee.png";